import { useState } from "react";
import classes from "./InfoSection.module.css";
import laptop from "../../../img/HomePageImg/laptop.png";
import step1 from "../../../img/HomePageImg/step1.png";
import step2 from "../../../img/HomePageImg/step2.png";
import step3 from "../../../img/HomePageImg/step3.png";
import arrow from "../../../img/HomePageImg/arrow.png";
import file1 from "../../../img/HomePageImg/file1.png";
import filtering from "../../../img/HomePageImg/filtering.png";
import file2 from "../../../img/HomePageImg/file2.png";
import hourglass from "../../../img/HomePageImg/hourglass.png";
import userRound from "../../../img/HomePageImg/user-round.png";
import uploadLogo from "../../../img/HomePageImg/uploadLogo.png";
import womanPhoto from "../../../img/HomePageImg/womanPhoto.png";
import manPhoto from "../../../img/HomePageImg/manPhoto.png";
import arrowDown from "../../../img/HomePageImg/arrowDown.svg";
import previewImage from "../../../img/HomePageImg/preview.png";
import { Link } from "react-router-dom";

function InfoSection() {
  const [showPreview, setShowPreview] = useState(false);

  return (
    <div className={classes.info_section}>
      {/* Preview Modal */}
      {showPreview && (
        <div className={classes.modal_overlay} onClick={() => setShowPreview(false)}>
          <div className={classes.modal_content} onClick={(e) => e.stopPropagation()}>
            <button className={classes.modal_close} onClick={() => setShowPreview(false)}>×</button>
            <img src={previewImage} alt="תצוגה מקדימה של הפלט" className={classes.preview_image} />
          </div>
        </div>
      )}

      <div className={classes.laptop_section}>
        <img src={laptop} alt="תצוגה מקדימה של המרת נסח טאבו לאקסל" loading="lazy" />
        <button onClick={() => setShowPreview(true)} className={classes.button}>
          <p>תצוגה מקדימה</p>
        </button>
      </div>
      <div className={classes.first_section}>
        <p>המרת נסחים בשלושה צעדים- איך זה עובד?</p>
      </div>
      <div className={classes.steps_container}>
        <div className={classes.step} data-step="1">
          <img src={step1} className={classes.circle_img} alt="שלב 1 - העלאת קובץ" loading="lazy" />
          <div className={classes.step_content}>
            <img src={file1} alt="העלאת קובץ PDF" loading="lazy" />
            <h3>העלאת קובץ</h3>
            <p>העלה קובץ pdf של נסח הטאבו שלך למערכת.</p>
          </div>
        </div>
        <img src={arrowDown} className={classes.step_arrow} alt="" aria-hidden="true" loading="lazy" />
        <div>
          <img src={arrow} className={classes.arrow} alt="" aria-hidden="true" loading="lazy" />
        </div>
        <div className={classes.step} data-step="2">
          <img src={step2} className={classes.circle_img} alt="שלב 2 - המרה אוטומטית" loading="lazy" />
          <div className={classes.step_content}>
            <img src={filtering} alt="המרת נתונים אוטומטית" loading="lazy" />
            <h3>המרת נתונים אוטומטית</h3>
            <p>המערכת שלנו ממירה ומארגנת את הנתונים באופן אוטומטי.</p>
          </div>
        </div>
        <img src={arrowDown} className={classes.step_arrow} alt="" aria-hidden="true" loading="lazy" />
        <div>
          <img src={arrow} className={classes.arrow} alt="" aria-hidden="true" loading="lazy" />
        </div>
        <div className={classes.step} data-step="3">
          <img src={step3} className={classes.circle_img} alt="שלב 3 - הורדת אקסל" loading="lazy" />
          <div className={classes.step_content}>
            <img src={file2} alt="קובץ אקסל מסודר" loading="lazy" />
            <h3>קובץ אקסל מסודר</h3>
            <p>קבל קובץ Excel מסודר מוכן להורדה.</p>
          </div>
        </div>
      </div>
      <div className={classes.third_section}>
        <p>על השירות של טאבופיי</p>
        <div className={classes.features_container}>
          <div className={classes.feature_card}>
            <img src={uploadLogo} alt="המרת נסחים בקלות" loading="lazy" />
            <h3 className={classes.feature_title}>המרת נסחים בקלות</h3>
            <p className={classes.feature_description}>
              ניתן להמיר בו זמנית בין נסח אחד ל-30 נסחים לקובץ Excel מרוכז
              ומסודר.
            </p>
          </div>
          <div className={classes.feature_card}>
            <img src={hourglass} alt="חוסך זמן ומונע טעויות" loading="lazy" />
            <h3 className={classes.feature_title}>חוסך לך זמן ומונע טעויות</h3>
            <p className={classes.feature_description}>
              ההמרה מתבצעת באופן אוטומטי, חוסכת זמן יקר ומונעת טעויות הקלדה.
            </p>
          </div>
          <div className={classes.feature_card}>
            <img src={userRound} alt="חבילת המרות מותאמת אישית" loading="lazy" />
            <h3 className={classes.feature_title}>חבילת המרות מותאמת אישית</h3>
            <p className={classes.feature_description}>
              ניתן לרכוש המרות ישירות לאחר הכניסה לאתר ולהתאים חבילת המרות
              חודשית מותאמת אישית.
            </p>
          </div>
        </div>
      </div>
      <div className={classes.testimonials_section}>
        <h2>מה המשתמשים שלנו אומרים?</h2>
        <div className={classes.testimonials_container}>
          <div className={classes.testimonial_card}>
            <img src={womanPhoto} alt="דנה - מתווכת נדל״ן מספרת על חווית השימוש ב-Tabufy" loading="lazy" />
            <div className={classes.testimonial_content}>
              <p className={classes.testimonial_text}>
                "חסכתי שעות של עבודה ידנית! האתר הזה פשוט משנה חיים. קל לשימוש
                והתוצאה מדויקת! "
              </p>
              <p className={classes.testimonial_author}>דנה, מתווכת נדל"ן</p>
            </div>
          </div>
          <div className={classes.testimonial_card}>
            <img src={manPhoto} alt="עו״ד יואב כהן ממליץ על Tabufy" loading="lazy" />
            <div className={classes.testimonial_content}>
              <p className={classes.testimonial_text}>
                "בתור עורך דין שמתעסק בנדל"ן, השירות הזה חוסך לי המון זמן. המרת
                נסחים לאקסל מעולם לא הייתה פשוטה יותר. "
              </p>
              <p className={classes.testimonial_author}>עו"ד יואב כהן</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InfoSection;
